import { Button } from '@wolfejs/ui/Button/Button';
import { Loading } from '@wolfejs/ui/Loading';
import { Modal } from '@wolfejs/ui/Modal';
import { Title } from '@wolfejs/ui/Title/Title';
import { UIColors, UISizes } from '@wolfejs/ui/types/UI';
import { cn } from '@wolfejs/ui/utils/classnames';
import Link from 'next/link';
import React from 'react';
import { DashboardPanel } from '../DashboardPanel/DashboardPanel';
import { DepositInfoModal } from './DepositInfoModal';
import type { FundMode } from './types';

type FundNoticeProps = {
  fundModes: FundMode[];
};
export const FundNoticeCard = ({ fundModes }: FundNoticeProps) => {
  const [fundMode, setFundMode] = React.useState<FundMode>(fundModes[0]);
  const [showModal, setShowModal] = React.useState(false);

  if (!fundModes) return <Loading />;
  return (
    <DashboardPanel classNames={{ content: 'flex flex-col gap-6' }} title="New Funding Notice">
      <div className="flex flex-col gap-12">
        <div className="flex gap-8">
          {fundModes.map(fund => (
            <Button
              key={fund.mode}
              className={cn({ ['text-primary border-primary border']: fundMode?.mode === fund.mode })}
              color={UIColors.primary}
              variant="ghost"
              onClick={() => setFundMode(fund)}
            >
              <div className="flex items-center gap-2">
                {fund.icon}
                {fund.mode}
              </div>
            </Button>
          ))}
        </div>
        <div className="flex flex-col gap-1">
          <Title as={'h4'} className="mb-0">
            {`Please reference the business name of your account and confirm deposit amount with your payment if possible.`}
          </Title>
          <span>
            If you require an invoice or purchase order number prior to funding your account, please{' '}
            <Link href={'mailto:ms-support@wolfe.com'} className="text-primary">
              contact us.
            </Link>
          </span>
        </div>
      </div>
      <div>
        <Button color={UIColors.primary} onClick={() => setShowModal(true)}>
          Deposit Information
        </Button>
      </div>
      {showModal && (
        <Modal
          title={'Deposit Funds'}
          open={showModal}
          onClose={() => setShowModal(false)}
          closeOnBackdropClick={true}
          backdrop={false}
        >
          <DepositInfoModal fundMode={fundMode} />
        </Modal>
      )}
    </DashboardPanel>
  );
};
